// extracted by mini-css-extract-plugin
var _1 = "LoaderText-moduleLoaderText__mseNi";
export { _1 as "LoaderText" }
